import { render } from "./CustomerViewSizes.vue?vue&type=template&id=3e2527f4&scoped=true"
import script from "./CustomerViewSizes.vue?vue&type=script&lang=js"
export * from "./CustomerViewSizes.vue?vue&type=script&lang=js"

import "./CustomerViewSizes.vue?vue&type=style&index=0&id=3e2527f4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2527f4"]])

export default __exports__